// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20width=%2712%27%20height=%2712%27%20viewBox=%270%200%2012%2012%27%3E%3Cpath%20fill=%27%23666%27%20d=%27M6%209L1%204h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  button {
    font-family: inherit;
    transition: all 0.2s ease;
    box-sizing: border-box;
  }

  button:focus {
    outline: 2px solid var(--color-accent-green);
    outline-offset: 2px;
  }
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-6 {
  bottom: -1.5rem;
}
.-bottom-\\[150px\\] {
  bottom: -150px;
}
.-left-20 {
  left: -5rem;
}
.-left-\\[200px\\] {
  left: -200px;
}
.-right-\\[150px\\] {
  right: -150px;
}
.-top-\\[200px\\] {
  top: -200px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-\\[3px\\] {
  left: 3px;
}
.left-\\[45px\\] {
  left: 45px;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-\\[10\\%\\] {
  right: 10%;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-6 {
  top: 1.5rem;
}
.top-\\[40\\%\\] {
  top: 40%;
}
.top-full {
  top: 100%;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[1001\\] {
  z-index: 1001;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1100\\] {
  z-index: 1100;
}
.z-\\[1150\\] {
  z-index: 1150;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2\\] {
  z-index: 2;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-full {
  grid-column: 1 / -1;
}
.m-0 {
  margin: 0px;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-lg {
  margin-top: 24px;
  margin-bottom: 24px;
}
.my-md {
  margin-top: 16px;
  margin-bottom: 16px;
}
.my-sm {
  margin-top: 8px;
  margin-bottom: 8px;
}
.-mb-px {
  margin-bottom: -1px;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-lg {
  margin-bottom: 24px;
}
.mb-md {
  margin-bottom: 16px;
}
.mb-sm {
  margin-bottom: 8px;
}
.mb-xl {
  margin-bottom: 32px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-40 {
  margin-right: 10rem;
}
.mr-auto {
  margin-right: auto;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.mt-md {
  margin-top: 16px;
}
.mt-sm {
  margin-top: 8px;
}
.mt-xl {
  margin-top: 32px;
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[86vh\\] {
  height: 86vh;
}
.h-\\[88vh\\] {
  height: 88vh;
}
.h-\\[calc\\(100\\%\\+12px\\)\\] {
  height: calc(100% + 12px);
}
.h-\\[calc\\(86vh-56px\\)\\] {
  height: calc(86vh - 56px);
}
.h-\\[calc\\(88vh-56px\\)\\] {
  height: calc(88vh - 56px);
}
.h-auto {
  height: auto;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-52 {
  max-height: 13rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[75vh\\] {
  max-height: 75vh;
}
.max-h-\\[82vh\\] {
  max-height: 82vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-full {
  max-height: 100%;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[32px\\] {
  min-height: 32px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[44px\\] {
  min-height: 44px;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[90vh\\] {
  min-height: 90vh;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-auto {
  width: auto !important;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[145px\\] {
  width: 145px;
}
.w-\\[22px\\] {
  width: 22px;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[500px\\] {
  width: 500px;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[16px\\] {
  min-width: 16px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[250px\\] {
  min-width: 250px;
}
.min-w-\\[60px\\] {
  min-width: 60px;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.min-w-\\[90px\\] {
  min-width: 90px;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.\\!max-w-fit {
  max-width: fit-content !important;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[1000px\\] {
  max-width: 1000px;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[11ch\\] {
  max-width: 11ch;
}
.max-w-\\[1200px\\] {
  max-width: 1200px;
}
.max-w-\\[1400px\\] {
  max-width: 1400px;
}
.max-w-\\[1600px\\] {
  max-width: 1600px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[40px\\] {
  max-width: 40px;
}
.max-w-\\[420px\\] {
  max-width: 420px;
}
.max-w-\\[460px\\] {
  max-width: 460px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[620px\\] {
  max-width: 620px;
}
.max-w-\\[700px\\] {
  max-width: 700px;
}
.max-w-\\[800px\\] {
  max-width: 800px;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.max-w-\\[90px\\] {
  max-width: 90px;
}
.max-w-fit {
  max-width: fit-content;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.border-collapse {
  border-collapse: collapse;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-4 {
  --tw-translate-x: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2\\.5 {
  --tw-translate-x: 0.625rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-8 {
  --tw-translate-y: 2rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[30px\\] {
  --tw-translate-y: 30px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.02\\] {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes orbFloat {

  0%, 100% {
    transform: translate(0, 0) scale(1);
  }

  33% {
    transform: translate(50px, -50px) scale(1.1);
  }

  66% {
    transform: translate(-30px, 30px) scale(0.9);
  }
}
.animate-\\[orbFloat_25s_ease-in-out_infinite\\] {
  animation: orbFloat 25s ease-in-out infinite;
}
@keyframes slideInLeft {

  from {
    opacity: 0;
    transform: translateX(-30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.animate-\\[slideInLeft_1s_cubic-bezier\\(0\\.16\\2c 1\\2c 0\\.3\\2c 1\\)_0\\.2s_both\\] {
  animation: slideInLeft 1s cubic-bezier(0.16,1,0.3,1) 0.2s both;
}
@keyframes slideInRight {

  from {
    opacity: 0;
    transform: translateX(30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.animate-\\[slideInRight_1s_cubic-bezier\\(0\\.16\\2c 1\\2c 0\\.3\\2c 1\\)_0\\.4s_both\\] {
  animation: slideInRight 1s cubic-bezier(0.16,1,0.3,1) 0.4s both;
}
@keyframes pulse {

  50% {
    opacity: .5;
    transform: scale(1.15);
    box-shadow: 0 8px 20px rgba(193, 122, 92, 0.6);
  }

  0%, 100% {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(193, 122, 92, 0.4);
  }
}
.animate-pulse {
  animation: pulse 2s infinite;
}
@keyframes slideIn {

  from {
    opacity: 0;
    transform: translateX(-10px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.animate-slideIn {
  animation: slideIn 0.5s ease;
}
@keyframes slideUp {

  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-slideUp {
  animation: slideUp 0.6s ease-out;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-\\[220px_1fr\\] {
  grid-template-columns: 220px 1fr;
}
.grid-cols-\\[auto_1fr_auto_2fr_1fr\\] {
  grid-template-columns: auto 1fr auto 2fr 1fr;
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(250px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fill,minmax(250px,1fr));
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(350px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fill,minmax(350px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(200px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(200px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(250px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(250px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(280px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(280px,1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-stretch {
  justify-content: stretch;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-lg {
  gap: 24px;
}
.gap-md {
  gap: 16px;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.space-y-lg > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(24px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(24px * var(--tw-space-y-reverse));
}
.space-y-md > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(16px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(16px * var(--tw-space-y-reverse));
}
.space-y-xs > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(4px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(4px * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-border > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(224 221 213 / var(--tw-divide-opacity, 1));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.self-end {
  align-self: flex-end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-lg {
  border-radius: 14px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[28px\\] {
  border-radius: 28px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 14px;
}
.rounded-md {
  border-radius: 8px;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 6px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-tl-2xl {
  border-top-left-radius: 1rem;
}
.rounded-tl-sm {
  border-top-left-radius: 6px;
}
.rounded-tr-sm {
  border-top-right-radius: 6px;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-\\[3px\\] {
  border-width: 3px;
}
.border-x-0 {
  border-left-width: 0px;
  border-right-width: 0px;
}
.border-y-0 {
  border-top-width: 0px;
  border-bottom-width: 0px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-l-\\[3px\\] {
  border-left-width: 3px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-dashed {
  border-style: dashed;
}
.\\!border-none {
  border-style: none !important;
}
.border-none {
  border-style: none;
}
.border-\\[\\#007bff\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 123 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1b355b\\] {
  --tw-border-opacity: 1;
  border-color: rgb(27 53 91 / var(--tw-border-opacity, 1));
}
.border-\\[\\#28a745\\] {
  --tw-border-opacity: 1;
  border-color: rgb(40 167 69 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2E2E2E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(46 46 46 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2E2E2E\\]\\/15 {
  border-color: rgb(46 46 46 / 0.15);
}
.border-\\[\\#6B7F5C\\] {
  --tw-border-opacity: 1;
  border-color: rgb(107 127 92 / var(--tw-border-opacity, 1));
}
.border-\\[\\#6B7F5C\\]\\/20 {
  border-color: rgb(107 127 92 / 0.2);
}
.border-\\[\\#6B7F5C\\]\\/30 {
  border-color: rgb(107 127 92 / 0.3);
}
.border-\\[\\#C17A5C\\] {
  --tw-border-opacity: 1;
  border-color: rgb(193 122 92 / var(--tw-border-opacity, 1));
}
.border-\\[\\#C17A5C\\]\\/20 {
  border-color: rgb(193 122 92 / 0.2);
}
.border-\\[\\#D5CFC2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(213 207 194 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E0DDD5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(224 221 213 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E0E0E0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(224 224 224 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E4E4E4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E6E6E6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 230 230 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EF9A9A\\] {
  --tw-border-opacity: 1;
  border-color: rgb(239 154 154 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F0F0F0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(240 240 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#b8daff\\] {
  --tw-border-opacity: 1;
  border-color: rgb(184 218 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#c33\\] {
  --tw-border-opacity: 1;
  border-color: rgb(204 51 51 / var(--tw-border-opacity, 1));
}
.border-\\[\\#c3e6cb\\] {
  --tw-border-opacity: 1;
  border-color: rgb(195 230 203 / var(--tw-border-opacity, 1));
}
.border-\\[\\#c8e6c9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(200 230 201 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ced4da\\] {
  --tw-border-opacity: 1;
  border-color: rgb(206 212 218 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d5dce8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(213 220 232 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dc3545\\] {
  --tw-border-opacity: 1;
  border-color: rgb(220 53 69 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dee2e6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(222 226 230 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e9ecef\\] {
  --tw-border-opacity: 1;
  border-color: rgb(233 236 239 / var(--tw-border-opacity, 1));
}
.border-\\[\\#f5c6cb\\] {
  --tw-border-opacity: 1;
  border-color: rgb(245 198 203 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ffeeba\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 238 186 / var(--tw-border-opacity, 1));
}
.border-\\[rgba\\(46\\2c 46\\2c 46\\2c 0\\.08\\)\\] {
  border-color: rgba(46,46,46,0.08);
}
.border-accent-green {
  --tw-border-opacity: 1;
  border-color: rgb(107 127 92 / var(--tw-border-opacity, 1));
}
.border-accent-green\\/20 {
  border-color: rgb(107 127 92 / 0.2);
}
.border-accent-green\\/25 {
  border-color: rgb(107 127 92 / 0.25);
}
.border-accent-green\\/30 {
  border-color: rgb(107 127 92 / 0.3);
}
.border-accent-terracotta {
  --tw-border-opacity: 1;
  border-color: rgb(193 122 92 / var(--tw-border-opacity, 1));
}
.border-amber-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-background {
  --tw-border-opacity: 1;
  border-color: rgb(245 241 232 / var(--tw-border-opacity, 1));
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-border {
  --tw-border-opacity: 1;
  border-color: rgb(224 221 213 / var(--tw-border-opacity, 1));
}
.border-border-light {
  --tw-border-opacity: 1;
  border-color: rgb(239 238 232 / var(--tw-border-opacity, 1));
}
.border-border-light\\/50 {
  border-color: rgb(239 238 232 / 0.5);
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-green-600 {
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity, 1));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-olive {
  --tw-border-opacity: 1;
  border-color: rgb(107 127 92 / var(--tw-border-opacity, 1));
}
.border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.border-orange-600 {
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity, 1));
}
.border-primary\\/10 {
  border-color: rgb(46 46 46 / 0.1);
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-status-error {
  --tw-border-opacity: 1;
  border-color: rgb(199 107 107 / var(--tw-border-opacity, 1));
}
.border-status-success {
  --tw-border-opacity: 1;
  border-color: rgb(127 168 118 / var(--tw-border-opacity, 1));
}
.border-status-success\\/30 {
  border-color: rgb(127 168 118 / 0.3);
}
.border-status-warning\\/30 {
  border-color: rgb(217 168 78 / 0.3);
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/40 {
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/60 {
  border-color: rgb(255 255 255 / 0.6);
}
.border-white\\/70 {
  border-color: rgb(255 255 255 / 0.7);
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-yellow-400 {
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.border-l-\\[var\\(--color-accent-green\\)\\] {
  border-left-color: var(--color-accent-green);
}
.border-l-amber-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-l-blue-600 {
  --tw-border-opacity: 1;
  border-left-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-l-gray-600 {
  --tw-border-opacity: 1;
  border-left-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-l-orange-600 {
  --tw-border-opacity: 1;
  border-left-color: rgb(234 88 12 / var(--tw-border-opacity, 1));
}
.border-l-purple-600 {
  --tw-border-opacity: 1;
  border-left-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
}
.border-l-red-600 {
  --tw-border-opacity: 1;
  border-left-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-t-accent-green {
  --tw-border-opacity: 1;
  border-top-color: rgb(107 127 92 / var(--tw-border-opacity, 1));
}
.border-t-blue-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-t-transparent {
  border-top-color: transparent;
}
.border-t-white {
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.\\!bg-accent-green {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(107 127 92 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#007bff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 123 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#17a2b8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(23 162 184 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1b355b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(27 53 91 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#28a745\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(40 167 69 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2E2E2E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(46 46 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6B7F5C\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(107 127 92 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6B7F5C\\]\\/10 {
  background-color: rgb(107 127 92 / 0.1);
}
.bg-\\[\\#6B7F5C\\]\\/15 {
  background-color: rgb(107 127 92 / 0.15);
}
.bg-\\[\\#6c757d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(108 117 125 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C17A5C\\]\\/15 {
  background-color: rgb(193 122 92 / 0.15);
}
.bg-\\[\\#C76B6B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(199 107 107 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E0F2F1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E0F7FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 247 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E1F5FE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(225 245 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E3F2FD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(227 242 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8EAF6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 234 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F5E9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 245 233 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3E5F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 229 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F1E8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 241 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F1E8\\]\\/80 {
  background-color: rgb(245 241 232 / 0.8);
}
.bg-\\[\\#F5F5F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F9FBE7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 251 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFAFA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FBE9E7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 233 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FCE4EC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 228 236 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDFCF9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 252 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFEBEE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF3E0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 243 224 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF7F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF8E1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 248 225 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFDE7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 253 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#cce5ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(204 229 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d4edda\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(212 237 218 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d9382a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 56 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d9534f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 83 79 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#dc3545\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 53 69 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e0e0e0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e7f3ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 243 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e8f5e9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 245 233 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6faf2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 250 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8d7da\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 215 218 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8f9fa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fee\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 238 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffc107\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffebee\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff3cd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 243 205 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fffaf0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  background-color: rgba(0,0,0,0.5);
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.6\\)\\] {
  background-color: rgba(0,0,0,0.6);
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.7\\)\\] {
  background-color: rgba(0,0,0,0.7);
}
.bg-\\[rgba\\(107\\2c 127\\2c 92\\2c 0\\.1\\)\\] {
  background-color: rgba(107,127,92,0.1);
}
.bg-\\[rgba\\(107\\2c 127\\2c 92\\2c 0\\.15\\)\\] {
  background-color: rgba(107,127,92,0.15);
}
.bg-\\[rgba\\(193\\2c 122\\2c 92\\2c 0\\.15\\)\\] {
  background-color: rgba(193,122,92,0.15);
}
.bg-\\[var\\(--color-accent-green\\)\\] {
  background-color: var(--color-accent-green);
}
.bg-accent-green {
  --tw-bg-opacity: 1;
  background-color: rgb(107 127 92 / var(--tw-bg-opacity, 1));
}
.bg-accent-green\\/10 {
  background-color: rgb(107 127 92 / 0.1);
}
.bg-accent-green\\/15 {
  background-color: rgb(107 127 92 / 0.15);
}
.bg-accent-green\\/30 {
  background-color: rgb(107 127 92 / 0.3);
}
.bg-accent-green\\/5 {
  background-color: rgb(107 127 92 / 0.05);
}
.bg-accent-terracotta {
  --tw-bg-opacity: 1;
  background-color: rgb(193 122 92 / var(--tw-bg-opacity, 1));
}
.bg-accent-terracotta\\/15 {
  background-color: rgb(193 122 92 / 0.15);
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-background {
  --tw-bg-opacity: 1;
  background-color: rgb(245 241 232 / var(--tw-bg-opacity, 1));
}
.bg-background-light {
  --tw-bg-opacity: 1;
  background-color: rgb(253 252 249 / var(--tw-bg-opacity, 1));
}
.bg-background-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(253 252 249 / var(--tw-bg-opacity, 1));
}
.bg-background\\/50 {
  background-color: rgb(245 241 232 / 0.5);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-border {
  --tw-bg-opacity: 1;
  background-color: rgb(224 221 213 / var(--tw-bg-opacity, 1));
}
.bg-border-light {
  --tw-bg-opacity: 1;
  background-color: rgb(239 238 232 / var(--tw-bg-opacity, 1));
}
.bg-charcoal {
  --tw-bg-opacity: 1;
  background-color: rgb(46 46 46 / var(--tw-bg-opacity, 1));
}
.bg-charcoal\\/50 {
  background-color: rgb(46 46 46 / 0.5);
}
.bg-current {
  background-color: currentColor;
}
.bg-cyan-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-700\\/80 {
  background-color: rgb(55 65 81 / 0.8);
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-lime-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity, 1));
}
.bg-olive {
  --tw-bg-opacity: 1;
  background-color: rgb(107 127 92 / var(--tw-bg-opacity, 1));
}
.bg-olive\\/70 {
  background-color: rgb(107 127 92 / 0.7);
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity, 1));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-pink-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(46 46 46 / var(--tw-bg-opacity, 1));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-status-error {
  --tw-bg-opacity: 1;
  background-color: rgb(199 107 107 / var(--tw-bg-opacity, 1));
}
.bg-status-error-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(253 234 234 / var(--tw-bg-opacity, 1));
}
.bg-status-error\\/15 {
  background-color: rgb(199 107 107 / 0.15);
}
.bg-status-processing-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(240 237 245 / var(--tw-bg-opacity, 1));
}
.bg-status-success-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(232 243 229 / var(--tw-bg-opacity, 1));
}
.bg-status-warning-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(255 244 224 / var(--tw-bg-opacity, 1));
}
.bg-surface {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}
.bg-terracotta {
  --tw-bg-opacity: 1;
  background-color: rgb(193 122 92 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-\\[linear-gradient\\(135deg\\2c rgba\\(107\\2c 127\\2c 92\\2c 0\\.12\\)\\2c rgba\\(245\\2c 241\\2c 232\\2c 0\\.92\\)\\2c rgba\\(193\\2c 122\\2c 92\\2c 0\\.12\\)\\)\\] {
  background-image: linear-gradient(135deg,rgba(107,127,92,0.12),rgba(245,241,232,0.92),rgba(193,122,92,0.12));
}
.bg-\\[linear-gradient\\(180deg\\2c \\#f8fbff_0\\%\\2c \\#ffffff_100\\%\\)\\] {
  background-image: linear-gradient(180deg,#f8fbff 0%,#ffffff 100%);
}
.bg-\\[radial-gradient\\(circle\\2c \\#2E2E2E_0\\%\\2c transparent_70\\%\\)\\] {
  background-image: radial-gradient(circle,#2E2E2E 0%,transparent 70%);
}
.bg-\\[radial-gradient\\(circle\\2c \\#6B7F5C_0\\%\\2c transparent_70\\%\\)\\] {
  background-image: radial-gradient(circle,#6B7F5C 0%,transparent 70%);
}
.bg-\\[radial-gradient\\(circle\\2c \\#C17A5C_0\\%\\2c transparent_70\\%\\)\\] {
  background-image: radial-gradient(circle,#C17A5C 0%,transparent 70%);
}
.bg-\\[url\\(\\'data\\:image\\/svg\\+xml\\2c \\%3Csvg\\%20xmlns\\=\\%27http\\:\\/\\/www\\.w3\\.org\\/2000\\/svg\\%27\\%20width\\=\\%2712\\%27\\%20height\\=\\%2712\\%27\\%20viewBox\\=\\%270\\%200\\%2012\\%2012\\%27\\%3E\\%3Cpath\\%20fill\\=\\%27\\%23666\\%27\\%20d\\=\\%27M6\\%209L1\\%204h10z\\%27\\/\\%3E\\%3C\\/svg\\%3E\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-\\[\\#F5F1E8\\] {
  --tw-gradient-from: #F5F1E8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 241 232 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-accent-green {
  --tw-gradient-from: #6B7F5C var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(107 127 92 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-accent-green\\/10 {
  --tw-gradient-from: rgb(107 127 92 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(107 127 92 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-accent-green\\/20 {
  --tw-gradient-from: rgb(107 127 92 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(107 127 92 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/70 {
  --tw-gradient-from: rgb(0 0 0 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/80 {
  --tw-gradient-from: rgb(0 0 0 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-terracotta {
  --tw-gradient-from: #C17A5C var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(193 122 92 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-black\\/10 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/40 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#1a1a1a\\] {
  --tw-gradient-to: #1a1a1a var(--tw-gradient-to-position);
}
.to-\\[\\#e0e0e0\\] {
  --tw-gradient-to: #e0e0e0 var(--tw-gradient-to-position);
}
.to-accent-green\\/30 {
  --tw-gradient-to: rgb(107 127 92 / 0.3) var(--tw-gradient-to-position);
}
.to-accent-green\\/5 {
  --tw-gradient-to: rgb(107 127 92 / 0.05) var(--tw-gradient-to-position);
}
.to-accent-terracotta {
  --tw-gradient-to: #C17A5C var(--tw-gradient-to-position);
}
.to-black\\/20 {
  --tw-gradient-to: rgb(0 0 0 / 0.2) var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-\\[right_12px_center\\] {
  background-position: right 12px center;
}
.bg-\\[right_16px_center\\] {
  background-position: right 16px center;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-2xl {
  padding: 48px;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-lg {
  padding: 24px;
}
.p-md {
  padding: 16px;
}
.p-xl {
  padding: 32px;
}
.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}
.px-md {
  padding-left: 16px;
  padding-right: 16px;
}
.px-xl {
  padding-left: 32px;
  padding-right: 32px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[12px\\] {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[14px\\] {
  padding-top: 14px;
  padding-bottom: 14px;
}
.py-\\[18px\\] {
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[60px\\] {
  padding-top: 60px;
  padding-bottom: 60px;
}
.py-\\[6px\\] {
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-md {
  padding-top: 16px;
  padding-bottom: 16px;
}
.py-sm {
  padding-top: 8px;
  padding-bottom: 8px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-md {
  padding-bottom: 16px;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[2px\\] {
  padding-top: 2px;
}
.pt-lg {
  padding-top: 24px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.font-\\[inherit\\] {
  font-family: inherit;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.\\!text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[0\\.75rem\\] {
  font-size: 0.75rem;
}
.text-\\[0\\.85rem\\] {
  font-size: 0.85rem;
}
.text-\\[0\\.95rem\\] {
  font-size: 0.95rem;
}
.text-\\[0\\.9rem\\] {
  font-size: 0.9rem;
}
.text-\\[1\\.1rem\\] {
  font-size: 1.1rem;
}
.text-\\[1\\.3rem\\] {
  font-size: 1.3rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[2rem\\] {
  font-size: 2rem;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[56px\\] {
  font-size: 56px;
}
.text-\\[64px\\] {
  font-size: 64px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-semibold {
  font-weight: 600 !important;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-\\[0\\.94\\] {
  line-height: 0.94;
}
.leading-\\[1\\.1\\] {
  line-height: 1.1;
}
.leading-\\[1\\.4\\] {
  line-height: 1.4;
}
.leading-\\[1\\.5\\] {
  line-height: 1.5;
}
.leading-\\[1\\.7\\] {
  line-height: 1.7;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[-0\\.2px\\] {
  letter-spacing: -0.2px;
}
.tracking-\\[-0\\.5px\\] {
  letter-spacing: -0.5px;
}
.tracking-\\[-1px\\] {
  letter-spacing: -1px;
}
.tracking-\\[-2px\\] {
  letter-spacing: -2px;
}
.tracking-\\[0\\.18em\\] {
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.22em\\] {
  letter-spacing: 0.22em;
}
.tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.3em\\] {
  letter-spacing: 0.3em;
}
.tracking-\\[0\\.4em\\] {
  letter-spacing: 0.4em;
}
.tracking-\\[0\\.4px\\] {
  letter-spacing: 0.4px;
}
.tracking-\\[10px\\] {
  letter-spacing: 10px;
}
.tracking-\\[2px\\] {
  letter-spacing: 2px;
}
.tracking-\\[6px\\] {
  letter-spacing: 6px;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#004085\\] {
  --tw-text-opacity: 1;
  color: rgb(0 64 133 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00796B\\] {
  --tw-text-opacity: 1;
  color: rgb(0 121 107 / var(--tw-text-opacity, 1));
}
.text-\\[\\#007bff\\] {
  --tw-text-opacity: 1;
  color: rgb(0 123 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00897B\\] {
  --tw-text-opacity: 1;
  color: rgb(0 137 123 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0097A7\\] {
  --tw-text-opacity: 1;
  color: rgb(0 151 167 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0277BD\\] {
  --tw-text-opacity: 1;
  color: rgb(2 119 189 / var(--tw-text-opacity, 1));
}
.text-\\[\\#155724\\] {
  --tw-text-opacity: 1;
  color: rgb(21 87 36 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1976D2\\] {
  --tw-text-opacity: 1;
  color: rgb(25 118 210 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1b355b\\] {
  --tw-text-opacity: 1;
  color: rgb(27 53 91 / var(--tw-text-opacity, 1));
}
.text-\\[\\#212529\\] {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2E2E2E\\] {
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2E7D32\\] {
  --tw-text-opacity: 1;
  color: rgb(46 125 50 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2c3e50\\] {
  --tw-text-opacity: 1;
  color: rgb(44 62 80 / var(--tw-text-opacity, 1));
}
.text-\\[\\#388E3C\\] {
  --tw-text-opacity: 1;
  color: rgb(56 142 60 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3949AB\\] {
  --tw-text-opacity: 1;
  color: rgb(57 73 171 / var(--tw-text-opacity, 1));
}
.text-\\[\\#495057\\] {
  --tw-text-opacity: 1;
  color: rgb(73 80 87 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5A5A5A\\] {
  --tw-text-opacity: 1;
  color: rgb(90 90 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5F5F5F\\] {
  --tw-text-opacity: 1;
  color: rgb(95 95 95 / var(--tw-text-opacity, 1));
}
.text-\\[\\#616161\\] {
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity, 1));
}
.text-\\[\\#626262\\] {
  --tw-text-opacity: 1;
  color: rgb(98 98 98 / var(--tw-text-opacity, 1));
}
.text-\\[\\#666666\\] {
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity, 1));
}
.text-\\[\\#666\\] {
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6B7F5C\\] {
  --tw-text-opacity: 1;
  color: rgb(107 127 92 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6D6D6D\\] {
  --tw-text-opacity: 1;
  color: rgb(109 109 109 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6c757d\\] {
  --tw-text-opacity: 1;
  color: rgb(108 117 125 / var(--tw-text-opacity, 1));
}
.text-\\[\\#721c24\\] {
  --tw-text-opacity: 1;
  color: rgb(114 28 36 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7A7A7A\\] {
  --tw-text-opacity: 1;
  color: rgb(122 122 122 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7B1FA2\\] {
  --tw-text-opacity: 1;
  color: rgb(123 31 162 / var(--tw-text-opacity, 1));
}
.text-\\[\\#856404\\] {
  --tw-text-opacity: 1;
  color: rgb(133 100 4 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8A8A8A\\] {
  --tw-text-opacity: 1;
  color: rgb(138 138 138 / var(--tw-text-opacity, 1));
}
.text-\\[\\#999\\] {
  --tw-text-opacity: 1;
  color: rgb(153 153 153 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9A9A9A\\] {
  --tw-text-opacity: 1;
  color: rgb(154 154 154 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A65E40\\] {
  --tw-text-opacity: 1;
  color: rgb(166 94 64 / var(--tw-text-opacity, 1));
}
.text-\\[\\#AFB42B\\] {
  --tw-text-opacity: 1;
  color: rgb(175 180 43 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B8842E\\] {
  --tw-text-opacity: 1;
  color: rgb(184 132 46 / var(--tw-text-opacity, 1));
}
.text-\\[\\#BDBDBD\\] {
  --tw-text-opacity: 1;
  color: rgb(189 189 189 / var(--tw-text-opacity, 1));
}
.text-\\[\\#BF360C\\] {
  --tw-text-opacity: 1;
  color: rgb(191 54 12 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C17A5C\\] {
  --tw-text-opacity: 1;
  color: rgb(193 122 92 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C2185B\\] {
  --tw-text-opacity: 1;
  color: rgb(194 24 91 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C62828\\] {
  --tw-text-opacity: 1;
  color: rgb(198 40 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C76B6B\\] {
  --tw-text-opacity: 1;
  color: rgb(199 107 107 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D32F2F\\] {
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E0E0E0\\] {
  --tw-text-opacity: 1;
  color: rgb(224 224 224 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EF6C00\\] {
  --tw-text-opacity: 1;
  color: rgb(239 108 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F57C00\\] {
  --tw-text-opacity: 1;
  color: rgb(245 124 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F9A825\\] {
  --tw-text-opacity: 1;
  color: rgb(249 168 37 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF8F00\\] {
  --tw-text-opacity: 1;
  color: rgb(255 143 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a94442\\] {
  --tw-text-opacity: 1;
  color: rgb(169 68 66 / var(--tw-text-opacity, 1));
}
.text-\\[\\#c33\\] {
  --tw-text-opacity: 1;
  color: rgb(204 51 51 / var(--tw-text-opacity, 1));
}
.text-\\[\\#d4e0f2\\] {
  --tw-text-opacity: 1;
  color: rgb(212 224 242 / var(--tw-text-opacity, 1));
}
.text-\\[\\#dc3545\\] {
  --tw-text-opacity: 1;
  color: rgb(220 53 69 / var(--tw-text-opacity, 1));
}
.text-\\[var\\(--color-primary\\)\\] {
  color: var(--color-primary);
}
.text-\\[var\\(--color-text-primary\\)\\] {
  color: var(--color-text-primary);
}
.text-accent-green {
  --tw-text-opacity: 1;
  color: rgb(107 127 92 / var(--tw-text-opacity, 1));
}
.text-accent-green-dark {
  --tw-text-opacity: 1;
  color: rgb(76 95 61 / var(--tw-text-opacity, 1));
}
.text-accent-green\\/60 {
  color: rgb(107 127 92 / 0.6);
}
.text-accent-terracotta {
  --tw-text-opacity: 1;
  color: rgb(193 122 92 / var(--tw-text-opacity, 1));
}
.text-accent-terracotta-dark {
  --tw-text-opacity: 1;
  color: rgb(166 94 64 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-beige {
  --tw-text-opacity: 1;
  color: rgb(245 241 232 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-charcoal {
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity, 1));
}
.text-cyan-800 {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-lime-800 {
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity, 1));
}
.text-olive {
  --tw-text-opacity: 1;
  color: rgb(107 127 92 / var(--tw-text-opacity, 1));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-orange-800 {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity, 1));
}
.text-pink-800 {
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / var(--tw-text-opacity, 1));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-status-error {
  --tw-text-opacity: 1;
  color: rgb(199 107 107 / var(--tw-text-opacity, 1));
}
.text-status-processing {
  --tw-text-opacity: 1;
  color: rgb(139 127 168 / var(--tw-text-opacity, 1));
}
.text-status-success {
  --tw-text-opacity: 1;
  color: rgb(127 168 118 / var(--tw-text-opacity, 1));
}
.text-status-warning {
  --tw-text-opacity: 1;
  color: rgb(217 168 78 / var(--tw-text-opacity, 1));
}
.text-surface {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-teal-800 {
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity, 1));
}
.text-terracotta {
  --tw-text-opacity: 1;
  color: rgb(193 122 92 / var(--tw-text-opacity, 1));
}
.text-text-primary {
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity, 1));
}
.text-text-secondary {
  --tw-text-opacity: 1;
  color: rgb(90 90 90 / var(--tw-text-opacity, 1));
}
.text-text-tertiary {
  --tw-text-opacity: 1;
  color: rgb(138 138 138 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/85 {
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.no-underline {
  text-decoration-line: none;
}
.placeholder-text-tertiary::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(138 138 138 / var(--tw-placeholder-opacity, 1));
}
.accent-accent-green {
  accent-color: #6B7F5C;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-15 {
  opacity: 0.15;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_24px_rgba\\(107\\2c 127\\2c 92\\2c 0\\.18\\)\\] {
  --tw-shadow: 0 10px 24px rgba(107,127,92,0.18);
  --tw-shadow-colored: 0 10px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\] {
  --tw-shadow: 0 10px 40px rgba(0,0,0,0.2);
  --tw-shadow-colored: 0 10px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 10px 40px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0 10px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_rgba\\(46\\2c 46\\2c 46\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 12px 32px rgba(46,46,46,0.06);
  --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 12px 40px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 12px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_40px_rgba\\(46\\2c 46\\2c 46\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 16px 40px rgba(46,46,46,0.08);
  --tw-shadow-colored: 0 16px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_16px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 2px 16px rgba(0,0,0,0.06);
  --tw-shadow-colored: 0 2px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 2px 4px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 2px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\] {
  --tw-shadow: 0 2px 8px rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 2px 8px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_rgba\\(0\\2c 123\\2c 255\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 2px 8px rgba(0,123,255,0.3);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_12px_rgba\\(107\\2c 127\\2c 92\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 4px 12px rgba(107,127,92,0.3);
  --tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 4px 20px rgba(0,0,0,0.08);
  --tw-shadow-colored: 0 4px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 4px 20px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0 4px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_20px_rgba\\(107\\2c 127\\2c 92\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 4px 20px rgba(107,127,92,0.3);
  --tw-shadow-colored: 0 4px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_24px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 4px 24px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 4px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_16px_rgba\\(193\\2c 122\\2c 92\\2c 0\\.4\\)\\] {
  --tw-shadow: 0 6px 16px rgba(193,122,92,0.4);
  --tw-shadow-colored: 0 6px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 8px 30px rgba(0,0,0,0.08);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgba\\(107\\2c 127\\2c 92\\2c 0\\.2\\)\\] {
  --tw-shadow: 0 8px 30px rgba(107,127,92,0.2);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 8px 24px rgba(46, 46, 46, 0.12);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 12px rgba(46, 46, 46, 0.1);
  --tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 3px rgba(46, 46, 46, 0.08);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-blue-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}
.blur-\\[100px\\] {
  --tw-blur: blur(100px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[80px\\] {
  --tw-blur: blur(80px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[90px\\] {
  --tw-blur: blur(90px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg {
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[10px\\] {
  --tw-backdrop-blur: blur(10px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[1px\\] {
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[border-color\\] {
  transition-property: border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-\\[cubic-bezier\\(0\\.16\\2c 1\\2c 0\\.3\\2c 1\\)\\] {
  transition-timing-function: cubic-bezier(0.16,1,0.3,1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[animation-delay\\:15s\\] {
  animation-delay: 15s;
}
.\\[animation-delay\\:8s\\] {
  animation-delay: 8s;
}

/* Enterprise Design System - Color Variables */
:root {
  /* Primary Colors */
  --color-primary: #2E2E2E;
  --color-primary-light: #3E3E3E;
  --color-primary-dark: #1E1E1E;
  
  /* Background Colors */
  --color-background: #F5F1E8;
  --color-background-secondary: #FDFCF9;
  --color-background-light: #FDFCF9;
  --color-surface: #FFFFFF;
  
  /* Accent Colors */
  --color-accent-green: #6B7F5C;
  --color-accent-green-light: #8A9F7B;
  --color-accent-green-dark: #4C5F3D;
  
  --color-accent-terracotta: #C17A5C;
  --color-accent-terracotta-light: #D4967E;
  --color-accent-terracotta-dark: #A65E40;
  
  /* Status Colors */
  --color-success: #7FA876;
  --color-success-bg: #E8F3E5;
  
  --color-warning: #D9A84E;
  --color-warning-bg: #FFF4E0;
  
  --color-error: #C76B6B;
  --color-error-bg: #FDEAEA;
  
  --color-processing: #8B7FA8;
  --color-processing-bg: #F0EDF5;
  
  /* Neutral Colors */
  --color-text-primary: #2E2E2E;
  --color-text-secondary: #5A5A5A;
  --color-text-tertiary: #8A8A8A;
  
  --color-border: #E0DDD5;
  --color-border-light: #EFEEE8;
  
  /* Layout-specific colors */
  --color-charcoal: #2E2E2E;
  --color-beige: #F5F1E8;
  --color-olive: #6B7F5C;
  --color-terracotta: #C17A5C;
  
  /* Shadows */
  --shadow-sm: 0 1px 3px rgba(46, 46, 46, 0.08);
  --shadow-md: 0 4px 12px rgba(46, 46, 46, 0.1);
  --shadow-lg: 0 8px 24px rgba(46, 46, 46, 0.12);
  
  /* Spacing */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  --spacing-2xl: 48px;
  
  /* Border Radius */
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 14px;
  --radius-full: 9999px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-background);
  color: var(--color-text-primary);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Global button styles converted from App.css */

/* Leave Management Styles */
.page-container {
  min-height: 100vh;
  background-color: var(--color-background);
  padding: 2rem;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding: 1.5rem 2rem;
  background-color: var(--color-surface);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--color-border-light);
}

.page-header h1 {
  font-size: 1.75rem;
  color: var(--color-primary);
  margin: 0;
  font-weight: 600;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.stat-card {
  background-color: var(--color-surface);
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--color-border-light);
  text-align: center;
}

.stat-card h3 {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  margin: 0 0 0.5rem 0;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-value {
  font-size: 2rem;
  color: var(--color-primary);
  font-weight: 700;
  margin: 0;
}

.stat-label {
  font-size: 0.75rem;
  color: var(--color-text-tertiary);
  margin-top: 0.25rem;
}

.filters-section {
  background-color: var(--color-surface);
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--color-border-light);
  margin-bottom: 2rem;
}

.filters-row {
  display: flex;
  gap: 1rem;
  align-items: end;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 150px;
}

.filter-group label {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.filter-group select,
.filter-group input {
  padding: 0.5rem;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-size: 0.875rem;
  background-color: var(--color-surface);
}

.table-container {
  background-color: var(--color-surface);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--color-border-light);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 720px;
}

.data-table th {
  background-color: var(--color-background);
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-border);
  font-size: 0.875rem;
}

.data-table td {
  padding: 1rem;
  border-bottom: 1px solid var(--color-border-light);
  font-size: 0.875rem;
  color: var(--color-text-primary);
}

.data-table tr:hover {
  background-color: var(--color-background-light);
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.status-pending {
  background-color: var(--color-warning-bg);
  color: var(--color-warning);
}

.status-approved {
  background-color: var(--color-success-bg);
  color: var(--color-success);
}

.status-rejected {
  background-color: var(--color-error-bg);
  color: var(--color-error);
}

.leave-type {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}

.leave-type.full_day {
  background-color: var(--color-error-bg);
  color: var(--color-error);
}

.leave-type.half_day {
  background-color: var(--color-warning-bg);
  color: var(--color-warning);
}

.reason-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rejection-reason {
  font-size: 0.75rem;
  color: var(--color-error);
  font-style: italic;
  margin-top: 0.25rem;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
}

.processed-info {
  font-size: 0.875rem;
}

.processed-info small {
  color: var(--color-text-tertiary);
}

.empty-state {
  text-align: center;
  padding: 3rem;
  color: var(--color-text-secondary);
}

.loading-message {
  text-align: center;
  padding: 3rem;
  color: var(--color-text-secondary);
}

.error-message {
  background-color: var(--color-error-bg);
  color: var(--color-error);
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  border: 1px solid var(--color-error);
}

.header-stats {
  display: flex;
  gap: 1rem;
  font-size: 0.875rem;
  color: var(--color-text-secondary);
}

.stat-item {
  padding: 0.5rem 1rem;
  background-color: var(--color-background);
  border-radius: 4px;
  font-weight: 500;
}

.employee-name {
  font-weight: 600;
  color: var(--color-text-primary);
}

.employee-email {
  color: var(--color-text-tertiary);
  font-size: 0.75rem;
}

.text-muted {
  color: var(--color-text-tertiary);
  font-style: italic;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: var(--color-surface);
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid var(--color-border-light);
}

.modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  color: var(--color-primary);
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.modal-close:hover {
  background-color: var(--color-background);
}

.modal-form {
  padding: 1.5rem;
}

.modal-body {
  padding: 1.5rem;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.5rem;
  border-top: 1px solid var(--color-border-light);
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-size: 0.875rem;
  background-color: var(--color-surface);
  transition: border-color 0.2s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--color-accent-green);
  box-shadow: 0 0 0 2px rgba(107, 127, 92, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.char-count {
  font-size: 0.75rem;
  color: var(--color-text-tertiary);
  margin-top: 0.25rem;
  display: block;
}

/* Button Styles */
.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background-color: var(--color-accent-green);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--color-accent-green-dark);
}

.btn-secondary {
  background-color: var(--color-background);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--color-background-secondary);
}

.btn-success {
  background-color: var(--color-success);
  color: white;
}

.btn-success:hover:not(:disabled) {
  background-color: #6B9462;
}

.btn-danger {
  background-color: var(--color-error);
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background-color: #B55555;
}

.btn-sm {
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
}
/*
 Leave Management Styles */
.leave-balances-section {
  margin: 2rem 0;
}

.balance-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;
}

.balance-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.balance-card.critical {
  border-left: 4px solid var(--color-error);
}

.balance-card.warning {
  border-left: 4px solid var(--color-warning);
}

.balance-card.good {
  border-left: 4px solid var(--color-success);
}

.balance-header {
  display: flex;
  justify-content: between;
  align-items: center;
  margin-bottom: 1rem;
}

.balance-header h3 {
  margin: 0;
  color: var(--color-text-primary);
}

.leave-type-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  margin-left: auto;
}

.balance-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.balance-stat {
  text-align: center;
}

.balance-stat .label {
  display: block;
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  margin-bottom: 0.25rem;
}

.balance-stat .value {
  display: block;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-text-primary);
}

.balance-stat .value.remaining {
  color: var(--color-success);
}

.balance-progress {
  margin-top: 1rem;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background-color: var(--color-border-light);
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background-color: var(--color-accent-green);
  transition: width 0.3s ease;
}

.progress-text {
  display: block;
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  margin-top: 0.5rem;
}

/* Leave Type Management */
.tab-navigation {
  display: flex;
  border-bottom: 1px solid var(--color-border);
  margin-bottom: 2rem;
}

.tab-button {
  padding: 1rem 2rem;
  border: none;
  background: none;
  color: var(--color-text-secondary);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.tab-button:hover {
  color: var(--color-text-primary);
}

.tab-button.active {
  color: var(--color-accent-green);
  border-bottom-color: var(--color-accent-green);
}

.form-section {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

/* Dashboard-style responsive behavior */
@media (max-width: 1024px) {
  .page-container {
    padding: 1.5rem;
  }

  .page-header {
    padding: 1rem 1.25rem;
  }
}

@media (max-width: 767px) {
  .page-container {
    min-height: auto;
    padding: 1rem;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1rem;
  }

  .filters-row {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-group {
    width: 100%;
    min-width: 0;
  }

  .stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 1rem;
  }

  .balance-cards {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 1rem;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .modal-actions {
    flex-direction: column-reverse;
  }

  .modal-actions .btn {
    width: 100%;
  }
}

.color-preview {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid var(--color-border);
}

.leave-type-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.leave-type-indicator {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.duration-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}

.duration-badge.full_day {
  background-color: var(--color-success-bg);
  color: var(--color-success);
}

.duration-badge.half_day {
  background-color: var(--color-warning-bg);
  color: var(--color-warning);
}

/* Weekly Off Configuration */
.weekly-off-config {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.day-selection {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.day-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.day-checkbox:hover {
  background-color: var(--color-background-light);
}

.day-checkbox input:checked + .day-name {
  color: var(--color-accent-green);
  font-weight: 600;
}

.weekly-off-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.weekly-off-item {
  padding: 0.5rem 1rem;
  background-color: var(--color-background-light);
  border: 1px solid var(--color-border);
  border-radius: 6px;
}

/* Balance Cards Grid */
.balance-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.balance-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.stat-item {
  text-align: center;
}

.stat-label {
  display: block;
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  margin-bottom: 0.25rem;
}

.stat-value {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: var(--color-text-primary);
}

/* Bulk Assignment */
.bulk-assignment-row {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr auto;
  gap: 1rem;
  align-items: end;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: var(--color-background-light);
  border-radius: 8px;
}

.bulk-assignment-controls {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

/* Utilization Bar */
.utilization-bar {
  position: relative;
  width: 100px;
  height: 20px;
  background-color: var(--color-border-light);
  border-radius: 10px;
  overflow: hidden;
}

.utilization-fill {
  height: 100%;
  background-color: var(--color-accent-green);
  transition: width 0.3s ease;
}

.utilization-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-text-primary);
}

/* Status Badges */
.badge {
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.badge-success {
  background-color: var(--color-success-bg);
  color: var(--color-success);
}

.badge-warning {
  background-color: var(--color-warning-bg);
  color: var(--color-warning);
}

.badge-error {
  background-color: var(--color-error-bg);
  color: var(--color-error);
}

/* Year Selector */
.year-selector {
  padding: 0.5rem 1rem;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background-color: var(--color-surface);
  color: var(--color-text-primary);
}

/* Section Headers */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.section-header h2 {
  margin: 0;
  color: var(--color-text-primary);
}

.section-header p {
  margin: 0.5rem 0 0 0;
  color: var(--color-text-secondary);
}

/* Current Config */
.current-config {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 2rem;
}

.current-config h3 {
  margin-top: 0;
  color: var(--color-text-primary);
}

/* Leave Balance Assignment */
.assignment-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.assignment-form .form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .balance-cards {
    grid-template-columns: 1fr;
  }
  
  .balance-cards-grid {
    grid-template-columns: 1fr;
  }
  
  .day-selection {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .bulk-assignment-row {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}/* E
mployee Search */
.employee-search {
  margin-bottom: 2rem;
}

.search-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background-color: var(--color-surface);
  color: var(--color-text-primary);
  font-size: 0.875rem;
}

.search-input:focus {
  outline: none;
  border-color: var(--color-accent-green);
  box-shadow: 0 0 0 2px rgba(107, 127, 92, 0.1);
}

.search-input::placeholder {
  color: var(--color-text-tertiary);
}

/* Text warning styles */
.text-warning {
  color: var(--color-warning);
  font-size: 0.75rem;
  margin-top: 0.25rem;
  display: block;
}

/* Assignment form section */
.assignment-form-section {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.assignment-form-section h2 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: var(--color-text-primary);
}

/* ── Video Carousel – hide scrollbar ── */
.no-scrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* ── Animations ── */
@keyframes slideUp {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes slideIn {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}
.animate-slideUp { animation: slideUp 0.3s cubic-bezier(0.16,1,0.3,1) both; }
.animate-slideIn { animation: slideIn 0.2s ease both; }

/* ══════════════════════════════════════════════════════════════════════════
   Application Stepper Navigation Styles
   ══════════════════════════════════════════════════════════════════════════ */

/* ── Workflow Section Container Transitions ── */
.workflow-section-container {
  transition: opacity 300ms ease-in-out;
  will-change: opacity;
}

/* Fade in animation for entering sections */
.workflow-section-enter {
  opacity: 0;
}

.workflow-section-enter-active {
  opacity: 1;
  transition: opacity 300ms ease-in-out;
}

/* Fade out animation for exiting sections */
.workflow-section-exit {
  opacity: 1;
}

.workflow-section-exit-active {
  opacity: 0;
  transition: opacity 300ms ease-in-out;
}

/* ── Stepper Step States ── */

/* Active step styling - highlighted with ring effect */
.stepper-step-active {
  background-color: #2563eb; /* blue-600 */
  color: white;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
  transform: scale(1.05);
}

.stepper-step-active-label {
  color: #2563eb; /* blue-600 */
  font-weight: 600;
}

/* Completed step styling - green with checkmark */
.stepper-step-completed {
  background-color: #22c55e; /* green-500 */
  color: white;
}

.stepper-step-completed-label {
  color: #16a34a; /* green-600 */
  font-weight: 500;
}

/* Disabled/future step styling - muted appearance */
.stepper-step-disabled {
  background-color: #e5e7eb; /* gray-200 */
  color: #9ca3af; /* gray-400 */
  cursor: not-allowed;
  opacity: 0.6;
}

.stepper-step-disabled-label {
  color: #9ca3af; /* gray-400 */
}

/* Accessible step styling - can be clicked */
.stepper-step-accessible {
  background-color: #d1d5db; /* gray-300 */
  color: #4b5563; /* gray-600 */
  cursor: pointer;
  transition: all 200ms ease-in-out;
}

.stepper-step-accessible:hover {
  background-color: #9ca3af; /* gray-400 */
  transform: scale(1.05);
}

.stepper-step-accessible:focus {
  outline: 2px solid var(--color-accent-green);
  outline-offset: 2px;
}

/* ── Step Connector Lines ── */
.stepper-connector {
  height: 2px;
  background-color: #d1d5db; /* gray-300 */
  transition: background-color 200ms ease-in-out;
}

.stepper-connector-completed {
  background-color: #22c55e; /* green-500 */
}

/* ── Focus States for Accessibility ── */
.stepper-step:focus-visible {
  outline: 2px solid var(--color-accent-green);
  outline-offset: 3px;
  border-radius: 50%;
}

.stepper-step:focus:not(:focus-visible) {
  outline: none;
}

/* ── Mobile Responsive Styles ── */
@media (max-width: 767px) {
  /* Ensure touch-friendly targets on mobile */
  .stepper-step-mobile {
    min-width: 44px;
    min-height: 44px;
    touch-action: manipulation;
  }

  /* Mobile stepper container - horizontal scroll */
  .stepper-mobile-container {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: #d1d5db transparent;
  }

  .stepper-mobile-container::-webkit-scrollbar {
    height: 4px;
  }

  .stepper-mobile-container::-webkit-scrollbar-track {
    background: transparent;
  }

  .stepper-mobile-container::-webkit-scrollbar-thumb {
    background-color: #d1d5db;
    border-radius: 2px;
  }

  /* Abbreviated labels on mobile */
  .stepper-label-mobile {
    font-size: 0.75rem;
    max-width: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Smaller connector lines on mobile */
  .stepper-connector-mobile {
    width: 32px;
    height: 2px;
    margin: 0 4px;
  }
}

/* ── Desktop Responsive Styles ── */
@media (min-width: 768px) {
  /* Full labels on desktop */
  .stepper-label-desktop {
    font-size: 0.875rem;
    white-space: nowrap;
  }

  /* Larger step circles on desktop */
  .stepper-step-desktop {
    width: 40px;
    height: 40px;
  }

  /* Flexible connector lines on desktop */
  .stepper-connector-desktop {
    flex: 1 1;
    height: 2px;
    margin: 0 8px;
  }
}

/* ── Transition Performance Optimization ── */
.workflow-section-container,
.stepper-step,
.stepper-connector {
  /* Use GPU acceleration for smoother transitions */
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* ── Accessibility: Screen Reader Only Content ── */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* ── High Contrast Mode Support ── */
@media (prefers-contrast: high) {
  .stepper-step-active {
    border: 2px solid currentColor;
  }

  .stepper-step-completed {
    border: 2px solid currentColor;
  }

  .stepper-step-disabled {
    border: 2px solid currentColor;
  }
}

/* ── Reduced Motion Support ── */
@media (prefers-reduced-motion: reduce) {
  .workflow-section-container,
  .workflow-section-enter-active,
  .workflow-section-exit-active,
  .stepper-step,
  .stepper-connector {
    transition: none;
    animation: none;
  }
}

/* ── Loading State for Transitions ── */
.workflow-section-loading {
  opacity: 0.5;
  pointer-events: none;
  transition: opacity 150ms ease-in-out;
}

/* ── Step Number and Icon Styling ── */
.stepper-step-number {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1;
}

.stepper-step-icon {
  width: 20px;
  height: 20px;
}

/* ── Stepper Navigation Container ── */
.stepper-nav {
  background-color: white;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* ── Step Label Truncation ── */
.stepper-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100px;
}

@media (min-width: 768px) {
  .stepper-label {
    max-width: 120px;
  }
}

@media (min-width: 1024px) {
  .stepper-label {
    max-width: none;
  }
}

.file\\:mr-md::file-selector-button {
  margin-right: 16px;
}

.file\\:cursor-pointer::file-selector-button {
  cursor: pointer;
}

.file\\:rounded-sm::file-selector-button {
  border-radius: 6px;
}

.file\\:border-none::file-selector-button {
  border-style: none;
}

.file\\:bg-accent-green::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(107 127 92 / var(--tw-bg-opacity, 1));
}

.file\\:px-4::file-selector-button {
  padding-left: 1rem;
  padding-right: 1rem;
}

.file\\:py-2::file-selector-button {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.file\\:text-\\[13px\\]::file-selector-button {
  font-size: 13px;
}

.file\\:font-semibold::file-selector-button {
  font-weight: 600;
}

.file\\:text-surface::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.file\\:transition-all::file-selector-button {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.file\\:duration-200::file-selector-button {
  transition-duration: 200ms;
}

.placeholder\\:text-\\[\\#9A9A9A\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(154 154 154 / var(--tw-text-opacity, 1));
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:-left-full::before {
  content: var(--tw-content);
  left: -100%;
}

.before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}

.before\\:left-\\[-5\\%\\]::before {
  content: var(--tw-content);
  left: -5%;
}

.before\\:right-0::before {
  content: var(--tw-content);
  right: 0px;
}

.before\\:right-\\[-5\\%\\]::before {
  content: var(--tw-content);
  right: -5%;
}

.before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}

.before\\:top-\\[-10\\%\\]::before {
  content: var(--tw-content);
  top: -10%;
}

.before\\:z-0::before {
  content: var(--tw-content);
  z-index: 0;
}

.before\\:h-\\[300px\\]::before {
  content: var(--tw-content);
  height: 300px;
}

.before\\:h-\\[350px\\]::before {
  content: var(--tw-content);
  height: 350px;
}

.before\\:h-\\[40\\%\\]::before {
  content: var(--tw-content);
  height: 40%;
}

.before\\:h-full::before {
  content: var(--tw-content);
  height: 100%;
}

.before\\:w-\\[300px\\]::before {
  content: var(--tw-content);
  width: 300px;
}

.before\\:w-\\[350px\\]::before {
  content: var(--tw-content);
  width: 350px;
}

.before\\:w-full::before {
  content: var(--tw-content);
  width: 100%;
}

@keyframes floatSlow {

  0%, 100% {
    content: var(--tw-content);
    transform: translate(0, 0);
  }

  50% {
    content: var(--tw-content);
    transform: translate(20px, -20px);
  }
}

.before\\:animate-\\[floatSlow_28s_ease-in-out_infinite\\]::before {
  content: var(--tw-content);
  animation: floatSlow 28s ease-in-out infinite;
}

@keyframes floatSlow {

  0%, 100% {
    content: var(--tw-content);
    transform: translate(0, 0);
  }

  50% {
    content: var(--tw-content);
    transform: translate(20px, -20px);
  }
}

.before\\:animate-floatSlow::before {
  content: var(--tw-content);
  animation: floatSlow 25s ease-in-out infinite;
}

.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:bg-accent-green::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(107 127 92 / var(--tw-bg-opacity, 1));
}

.before\\:bg-accent-terracotta::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(193 122 92 / var(--tw-bg-opacity, 1));
}

.before\\:bg-gradient-to-br::before {
  content: var(--tw-content);
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.before\\:bg-gradient-to-r::before {
  content: var(--tw-content);
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.before\\:from-accent-green::before {
  content: var(--tw-content);
  --tw-gradient-from: #6B7F5C var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(107 127 92 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.before\\:from-transparent::before {
  content: var(--tw-content);
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.before\\:via-white\\/30::before {
  content: var(--tw-content);
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.before\\:to-accent-green-dark::before {
  content: var(--tw-content);
  --tw-gradient-to: #4C5F3D var(--tw-gradient-to-position);
}

.before\\:to-transparent::before {
  content: var(--tw-content);
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}

.before\\:opacity-\\[0\\.06\\]::before {
  content: var(--tw-content);
  opacity: 0.06;
}

.before\\:transition-\\[left\\]::before {
  content: var(--tw-content);
  transition-property: left;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:duration-500::before {
  content: var(--tw-content);
  transition-duration: 500ms;
}

.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:bottom-\\[-10\\%\\]::after {
  content: var(--tw-content);
  bottom: -10%;
}

.after\\:left-\\[-5\\%\\]::after {
  content: var(--tw-content);
  left: -5%;
}

.after\\:right-\\[-5\\%\\]::after {
  content: var(--tw-content);
  right: -5%;
}

.after\\:z-0::after {
  content: var(--tw-content);
  z-index: 0;
}

.after\\:h-\\[300px\\]::after {
  content: var(--tw-content);
  height: 300px;
}

.after\\:h-\\[400px\\]::after {
  content: var(--tw-content);
  height: 400px;
}

.after\\:w-\\[300px\\]::after {
  content: var(--tw-content);
  width: 300px;
}

.after\\:w-\\[400px\\]::after {
  content: var(--tw-content);
  width: 400px;
}

@keyframes floatSlow {

  0%, 100% {
    content: var(--tw-content);
    transform: translate(0, 0);
  }

  50% {
    content: var(--tw-content);
    transform: translate(20px, -20px);
  }
}

.after\\:animate-\\[floatSlow_32s_ease-in-out_infinite_reverse\\]::after {
  content: var(--tw-content);
  animation: floatSlow 32s ease-in-out infinite reverse;
}

@keyframes floatSlow {

  0%, 100% {
    content: var(--tw-content);
    transform: translate(0, 0);
  }

  50% {
    content: var(--tw-content);
    transform: translate(20px, -20px);
  }
}

.after\\:animate-floatSlowReverse::after {
  content: var(--tw-content);
  animation: floatSlow 30s ease-in-out infinite reverse;
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:bg-accent-green::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(107 127 92 / var(--tw-bg-opacity, 1));
}

.after\\:bg-accent-terracotta::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(193 122 92 / var(--tw-bg-opacity, 1));
}

.after\\:opacity-\\[0\\.06\\]::after {
  content: var(--tw-content);
  opacity: 0.06;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

.last\\:mb-0:last-child {
  margin-bottom: 0px;
}

.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}

.focus-within\\:border-accent-green\\/50:focus-within {
  border-color: rgb(107 127 92 / 0.5);
}

.focus-within\\:ring-1:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-accent-green\\/20:focus-within {
  --tw-ring-color: rgb(107 127 92 / 0.2);
}

.hover\\:-m-1:hover {
  margin: -0.25rem;
}

.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-\\[1px\\]:hover {
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-px:hover {
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:translate-x-1:hover {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:rounded-md:hover {
  border-radius: 8px;
}

.hover\\:border-\\[\\#007bff\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 123 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#adb5bd\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(173 181 189 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[var\\(--color-accent-green\\)\\]:hover {
  border-color: var(--color-accent-green);
}

.hover\\:border-accent-green:hover {
  --tw-border-opacity: 1;
  border-color: rgb(107 127 92 / var(--tw-border-opacity, 1));
}

.hover\\:border-accent-green\\/30:hover {
  border-color: rgb(107 127 92 / 0.3);
}

.hover\\:border-accent-terracotta:hover {
  --tw-border-opacity: 1;
  border-color: rgb(193 122 92 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}

.hover\\:border-olive\\/50:hover {
  border-color: rgb(107 127 92 / 0.5);
}

.hover\\:border-primary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(46 46 46 / var(--tw-border-opacity, 1));
}

.hover\\:border-text-secondary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(90 90 90 / var(--tw-border-opacity, 1));
}

.hover\\:bg-\\[\\#0056b3\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 86 179 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#138496\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(19 132 150 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#142844\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(20 40 68 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1f1f1f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 31 31 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#218838\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(33 136 56 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#2E2E2E\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(46 46 46 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#4d5f6b\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(77 95 107 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#5a6268\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(90 98 104 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#5a6b4d\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(90 107 77 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#5a6e4d\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(90 110 77 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#5d7150\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(93 113 80 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#6B7F5C\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 127 92 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#6B7F5C\\]\\/5:hover {
  background-color: rgb(107 127 92 / 0.05);
}

.hover\\:bg-\\[\\#B05555\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(176 85 85 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#B71C1C\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(183 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#C17A5C\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(193 122 92 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#E0E0E0\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F5F5F5\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#c82333\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(200 35 51 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#c9302c\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(201 48 44 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e0a800\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 168 0 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e8e4d8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(232 228 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#eef3fb\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 243 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f8f9fa\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[rgba\\(107\\2c 127\\2c 92\\2c 0\\.05\\)\\]:hover {
  background-color: rgba(107,127,92,0.05);
}

.hover\\:bg-\\[rgba\\(107\\2c 127\\2c 92\\2c 0\\.1\\)\\]:hover {
  background-color: rgba(107,127,92,0.1);
}

.hover\\:bg-\\[var\\(--color-accent-green-dark\\)\\]:hover {
  background-color: var(--color-accent-green-dark);
}

.hover\\:bg-accent-green:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 127 92 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-accent-green-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(76 95 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-accent-green\\/20:hover {
  background-color: rgb(107 127 92 / 0.2);
}

.hover\\:bg-amber-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-background:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 241 232 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-background-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 252 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-black\\/60:hover {
  background-color: rgb(0 0 0 / 0.6);
}

.hover\\:bg-black\\/80:hover {
  background-color: rgb(0 0 0 / 0.8);
}

.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-border\\/50:hover {
  background-color: rgb(224 221 213 / 0.5);
}

.hover\\:bg-emerald-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/40:hover {
  background-color: rgb(255 255 255 / 0.4);
}

.hover\\:bg-white\\/75:hover {
  background-color: rgb(255 255 255 / 0.75);
}

.hover\\:bg-white\\/\\[0\\.05\\]:hover {
  background-color: rgb(255 255 255 / 0.05);
}

.hover\\:bg-white\\/\\[0\\.08\\]:hover {
  background-color: rgb(255 255 255 / 0.08);
}

.hover\\:p-1:hover {
  padding: 0.25rem;
}

.hover\\:text-\\[\\#2E2E2E\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#2c3e50\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(44 62 80 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#333\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#F5F1E8\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(245 241 232 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[var\\(--color-primary\\)\\]:hover {
  color: var(--color-primary);
}

.hover\\:text-accent-green:hover {
  --tw-text-opacity: 1;
  color: rgb(107 127 92 / var(--tw-text-opacity, 1));
}

.hover\\:text-accent-green-dark:hover {
  --tw-text-opacity: 1;
  color: rgb(76 95 61 / var(--tw-text-opacity, 1));
}

.hover\\:text-accent-terracotta:hover {
  --tw-text-opacity: 1;
  color: rgb(193 122 92 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-900:hover {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-900:hover {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}

.hover\\:text-surface:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:no-underline:hover {
  text-decoration-line: none;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:shadow-\\[0_24px_50px_rgba\\(46\\2c 46\\2c 46\\2c 0\\.12\\)\\]:hover {
  --tw-shadow: 0 24px 50px rgba(46,46,46,0.12);
  --tw-shadow-colored: 0 24px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_2px_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\]:hover {
  --tw-shadow: 0 2px 8px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_2px_8px_rgba\\(0\\2c 123\\2c 255\\2c 0\\.2\\)\\]:hover {
  --tw-shadow: 0 2px 8px rgba(0,123,255,0.2);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_4px_12px_rgba\\(107\\2c 127\\2c 92\\2c 0\\.3\\)\\]:hover {
  --tw-shadow: 0 4px 12px rgba(107,127,92,0.3);
  --tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_4px_16px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\]:hover {
  --tw-shadow: 0 4px 16px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_8px_30px_rgba\\(107\\2c 127\\2c 92\\2c 0\\.4\\)\\]:hover {
  --tw-shadow: 0 8px 30px rgba(107,127,92,0.4);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_8px_32px_rgba\\(107\\2c 127\\2c 92\\2c 0\\.15\\)\\]:hover {
  --tw-shadow: 0 8px 32px rgba(107,127,92,0.15);
  --tw-shadow-colored: 0 8px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 8px 24px rgba(46, 46, 46, 0.12);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 12px rgba(46, 46, 46, 0.1);
  --tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 3px rgba(46, 46, 46, 0.08);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.file\\:hover\\:bg-accent-green-dark:hover::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(76 95 61 / var(--tw-bg-opacity, 1));
}

.hover\\:before\\:left-full:hover::before {
  content: var(--tw-content);
  left: 100%;
}

.focus\\:border-\\[\\#007bff\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 123 255 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#6B7F5C\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(107 127 92 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#C76B6B\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(199 107 107 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[var\\(--color-accent-green\\)\\]:focus {
  border-color: var(--color-accent-green);
}

.focus\\:border-accent-green:focus {
  --tw-border-opacity: 1;
  border-color: rgb(107 127 92 / var(--tw-border-opacity, 1));
}

.focus\\:border-blue-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:shadow-\\[0_0_0_3px_rgba\\(0\\2c 123\\2c 255\\2c 0\\.1\\)\\]:focus {
  --tw-shadow: 0 0 0 3px rgba(0,123,255,0.1);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:shadow-\\[0_0_0_3px_rgba\\(107\\2c 127\\2c 92\\2c 0\\.1\\)\\]:focus {
  --tw-shadow: 0 0 0 3px rgba(107,127,92,0.1);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-accent-green:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 127 92 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-accent-green\\/40:focus {
  --tw-ring-color: rgb(107 127 92 / 0.4);
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-green-700\\/30:focus {
  --tw-ring-color: rgb(21 128 61 / 0.3);
}

.focus\\:ring-primary:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(46 46 46 / var(--tw-ring-opacity, 1));
}

.active\\:translate-y-0:active {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:enabled\\:bg-accent-green-dark:enabled:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(76 95 61 / var(--tw-bg-opacity, 1));
}

.hover\\:enabled\\:bg-background-light:enabled:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 252 249 / var(--tw-bg-opacity, 1));
}

.active\\:enabled\\:translate-y-0:enabled:active {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.disabled\\:transform-none:disabled {
  transform: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:bg-\\[\\#e9ecef\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(233 236 239 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-background:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(245 241 232 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-background-light:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(253 252 249 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-100:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-400:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}

.disabled\\:text-gray-600:disabled {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.disabled\\:text-text-secondary:disabled {
  --tw-text-opacity: 1;
  color: rgb(90 90 90 / var(--tw-text-opacity, 1));
}

.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group\\/carousel:hover .group-hover\\/carousel\\:opacity-100 {
  opacity: 1;
}

.group\\/textcarousel:hover .group-hover\\/textcarousel\\:opacity-100 {
  opacity: 1;
}

@media (max-width: 480px) {

  .max-\\[480px\\]\\:p-3 {
    padding: 0.75rem;
  }
}

@media (min-width: 640px) {

  .sm\\:bottom-8 {
    bottom: 2rem;
  }

  .sm\\:left-6 {
    left: 1.5rem;
  }

  .sm\\:right-6 {
    right: 1.5rem;
  }

  .sm\\:top-5 {
    top: 1.25rem;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .sm\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .sm\\:mb-8 {
    margin-bottom: 2rem;
  }

  .sm\\:mt-8 {
    margin-top: 2rem;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-3 {
    height: 0.75rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-\\[18px\\] {
    height: 18px;
  }

  .sm\\:h-\\[600px\\] {
    height: 600px;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-3 {
    width: 0.75rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-\\[18px\\] {
    width: 18px;
  }

  .sm\\:w-\\[320px\\] {
    width: 320px;
  }

  .sm\\:w-\\[350px\\] {
    width: 350px;
  }

  .sm\\:flex-1 {
    flex: 1 1;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:p-2\\.5 {
    padding: 0.625rem;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:pt-6 {
    padding-top: 1.5rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 768px) {

  .md\\:relative {
    position: relative;
  }

  .md\\:z-10 {
    z-index: 10;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:m-0 {
    margin: 0px;
  }

  .md\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-11 {
    height: 2.75rem;
  }

  .md\\:h-\\[18px\\] {
    height: 18px;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:w-11 {
    width: 2.75rem;
  }

  .md\\:w-16 {
    width: 4rem;
  }

  .md\\:w-56 {
    width: 14rem;
  }

  .md\\:w-60 {
    width: 15rem;
  }

  .md\\:w-\\[18px\\] {
    width: 18px;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:min-w-0 {
    min-width: 0px;
  }

  .md\\:min-w-\\[60px\\] {
    min-width: 60px;
  }

  .md\\:max-w-full {
    max-width: 100%;
  }

  .md\\:flex-1 {
    flex: 1 1;
  }

  .md\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[1fr_auto\\] {
    grid-template-columns: 1fr auto;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .md\\:flex-wrap {
    flex-wrap: wrap;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:items-stretch {
    align-items: stretch;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-1 {
    gap: 0.25rem;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:p-2xl {
    padding: 48px;
  }

  .md\\:p-4 {
    padding: 1rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-lg {
    padding-left: 24px;
    padding-right: 24px;
  }

  .md\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-\\[10px\\] {
    font-size: 10px;
  }

  .md\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .md\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 1024px) {

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:mb-12 {
    margin-bottom: 3rem;
  }

  .lg\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .lg\\:mb-8 {
    margin-bottom: 2rem;
  }

  .lg\\:ml-auto {
    margin-left: auto;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-12 {
    height: 3rem;
  }

  .lg\\:h-5 {
    height: 1.25rem;
  }

  .lg\\:h-\\[700px\\] {
    height: 700px;
  }

  .lg\\:w-12 {
    width: 3rem;
  }

  .lg\\:w-5 {
    width: 1.25rem;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:min-w-\\[70px\\] {
    min-width: 70px;
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1\\.12fr_0\\.88fr\\] {
    grid-template-columns: 1.12fr 0.88fr;
  }

  .lg\\:grid-cols-\\[1\\.2fr_0\\.8fr\\] {
    grid-template-columns: 1.2fr 0.8fr;
  }

  .lg\\:grid-cols-\\[2fr_1fr\\] {
    grid-template-columns: 2fr 1fr;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-end {
    align-items: flex-end;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-1 {
    gap: 0.25rem;
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:p-4 {
    padding: 1rem;
  }

  .lg\\:p-6 {
    padding: 1.5rem;
  }

  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .lg\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:text-right {
    text-align: right;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:block {
    display: block;
  }

  .xl\\:w-\\[280px\\] {
    width: 280px;
  }

  .xl\\:w-\\[380px\\] {
    width: 380px;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:p-10 {
    padding: 2.5rem;
  }

  .xl\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .xl\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\:hover\\]\\:bg-text-secondary::-webkit-scrollbar-thumb:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(90 90 90 / var(--tw-bg-opacity, 1));
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded::-webkit-scrollbar-thumb {
  border-radius: 0.25rem;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-border::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(224 221 213 / var(--tw-bg-opacity, 1));
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:rounded::-webkit-scrollbar-track {
  border-radius: 0.25rem;
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-background-light::-webkit-scrollbar-track {
  --tw-bg-opacity: 1;
  background-color: rgb(253 252 249 / var(--tw-bg-opacity, 1));
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:h-2::-webkit-scrollbar {
  height: 0.5rem;
}

.\\[\\&\\:not\\(\\:last-child\\)\\.active\\]\\:after\\:bg-accent-green:not(:last-child).active::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(107 127 92 / var(--tw-bg-opacity, 1));
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:absolute:not(:last-child)::after {
  content: var(--tw-content);
  position: absolute;
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:left-1\\/2:not(:last-child)::after {
  content: var(--tw-content);
  left: 50%;
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:top-5:not(:last-child)::after {
  content: var(--tw-content);
  top: 1.25rem;
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:z-\\[-1\\]:not(:last-child)::after {
  content: var(--tw-content);
  z-index: -1;
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:h-\\[2px\\]:not(:last-child)::after {
  content: var(--tw-content);
  height: 2px;
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:w-full:not(:last-child)::after {
  content: var(--tw-content);
  width: 100%;
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:bg-border:not(:last-child)::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(224 221 213 / var(--tw-bg-opacity, 1));
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:content-\\[\\'\\'\\]:not(:last-child)::after {
  --tw-content: '';
  content: var(--tw-content);
}

@media (min-width: 768px) {

  .md\\:\\[\\&\\>button\\]\\:w-full>button {
    width: 100%;
  }
}

@media (min-width: 960px) {

  .min-\\[960px\\]\\:\\[\\&\\>button\\]\\:justify-self-end>button {
    justify-self: end;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,oBAAc;IAAd,yBAAc;IAAd,sBAAc;EAAA;;EAAd;IAAA,4CAAc;IAAd,mBAAc;EAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,WAAmB;IAAnB,sBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,qBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;;EAE7B,sBAAsB;EACtB,2BAA2B;EAC3B,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;;EAExB,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;EACnC,kCAAkC;;EAElC,kCAAkC;EAClC,wCAAwC;EACxC,uCAAuC;;EAEvC,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;;EAE3B,wBAAwB;EACxB,2BAA2B;;EAE3B,sBAAsB;EACtB,yBAAyB;;EAEzB,2BAA2B;EAC3B,8BAA8B;;EAE9B,mBAAmB;EACnB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;;EAE9B,uBAAuB;EACvB,6BAA6B;;EAE7B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;;EAE3B,YAAY;EACZ,6CAA6C;EAC7C,6CAA6C;EAC7C,8CAA8C;;EAE9C,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE;aACW;AACb;;AAEA,gDAAgD;;AAchD,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;EACtC,kBAAkB;EAClB,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,wCAAwC;EACxC,2CAA2C;EAC3C,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;0BAC0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;EAC/C,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF,CAAC;gBACe;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA,mBAAmB,uDAAuD,EAAE;AAC5E,mBAAmB,iCAAiC,EAAE;;AAEtD;;+EAE+E;;AAE/E,iDAAiD;AACjD;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA,4CAA4C;AAC5C;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA,8BAA8B;;AAE9B,uDAAuD;AACvD;EACE,yBAAyB,EAAE,aAAa;EACxC,YAAY;EACZ,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,yBAAyB,EAAE,cAAc;EACzC,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,cAAc;EAC9B,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,yBAAyB,EAAE,aAAa;EACxC,cAAc,EAAE,aAAa;EAC7B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,aAAa;AAC/B;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB,EAAE,aAAa;EACxC,cAAc,EAAE,aAAa;EAC7B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,aAAa;EACxC,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,yBAAyB,EAAE,aAAa;EACxC,8CAA8C;AAChD;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA,yCAAyC;AACzC;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,4CAA4C;EAC5C;IACE,eAAe;IACf,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA,iDAAiD;EACjD;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB;IACrB,oCAAoC;EACtC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,WAAW;IACX,WAAW;IACX,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE,2BAA2B;EAC3B;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,mCAAmC;EACnC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,wCAAwC;EACxC;IACE,SAAO;IACP,WAAW;IACX,aAAa;EACf;AACF;;AAEA,8CAA8C;AAC9C;;;EAGE,kDAAkD;EAClD,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,iCAAiC;AACjC;EACE;;;;;IAKE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yCAAyC;AAC3C;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AA70CA;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,mBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,wBA60CC;EA70CD,wDA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;;EAAA;IAAA,0BA60CC;IA70CD;EA60CC;;EA70CD;IAAA,0BA60CC;IA70CD;EA60CC;AAAA;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;;EAAA;IAAA,0BA60CC;IA70CD;EA60CC;;EA70CD;IAAA,0BA60CC;IA70CD;EA60CC;AAAA;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD,4DA60CC;EA70CD,oEA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD,gEA60CC;EA70CD,+DA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD,sEA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD,yBA60CC;EA70CD,wDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,gBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;;EAAA;IAAA,0BA60CC;IA70CD;EA60CC;;EA70CD;IAAA,0BA60CC;IA70CD;EA60CC;AAAA;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;;EAAA;IAAA,0BA60CC;IA70CD;EA60CC;;EA70CD;IAAA,0BA60CC;IA70CD;EA60CC;AAAA;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,gBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,2GA60CC;EA70CD,yGA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,2BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,yBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,iBA60CC;EA70CD,iBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,4CA60CC;EA70CD,uDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sCA60CC;EA70CD,qDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0CA60CC;EA70CD,qDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,4CA60CC;EA70CD,sDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,uCA60CC;EA70CD,sDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,4CA60CC;EA70CD,sDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,6CA60CC;EA70CD,sDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,8CA60CC;EA70CD,sDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,6CA60CC;EA70CD,sDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,6CA60CC;EA70CD,qDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,sBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0CA60CC;EA70CD,qDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,2CA60CC;EA70CD,qDA60CC;EA70CD;AA60CC;;AA70CD;EAAA,8BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,2GA60CC;EA70CD,yGA60CC;EA70CD;AA60CC;;AA70CD;EAAA,2GA60CC;EA70CD,yGA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,qBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,qBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,yBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,iBA60CC;EA70CD,iBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,oBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;;EAAA;IAAA;EA60CC;AAAA;;AA70CD;;EAAA;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA,oBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,kBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,qBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,oBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,oBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,iBA60CC;IA70CD;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA,iBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,eA60CC;IA70CD;EA60CC;;EA70CD;IAAA,kBA60CC;IA70CD;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA,eA60CC;IA70CD;EA60CC;;EA70CD;IAAA,mBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,mBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,kBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,kBA60CC;IA70CD;EA60CC;AAAA;;AA70CD;;EAAA;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA,qBA60CC;IA70CD;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA,kBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,oBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,iBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,oBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,iBA60CC;IA70CD;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA,eA60CC;IA70CD;EA60CC;;EA70CD;IAAA,sBA60CC;IA70CD,8BA60CC;IA70CD;EA60CC;AAAA;;AA70CD;;EAAA;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA,kBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,kBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,oBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,kBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,iBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,iBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,iBA60CC;IA70CD;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA,iBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,iBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,mBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,kBA60CC;IA70CD;EA60CC;AAAA;;AA70CD;;EAAA;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA;EA60CC;;EA70CD;IAAA,kBA60CC;IA70CD;EA60CC;;EA70CD;IAAA,kBA60CC;IA70CD;EA60CC;AAAA;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD;AA60CC;;AA70CD;EAAA,0BA60CC;EA70CD,kBA60CC;EA70CD;AA60CC;;AA70CD;EAAA,gBA60CC;EA70CD;AA60CC;;AA70CD;;EAAA;IAAA;EA60CC;AAAA;;AA70CD;;EAAA;IAAA;EA60CC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Enterprise Design System - Color Variables */\n:root {\n  /* Primary Colors */\n  --color-primary: #2E2E2E;\n  --color-primary-light: #3E3E3E;\n  --color-primary-dark: #1E1E1E;\n  \n  /* Background Colors */\n  --color-background: #F5F1E8;\n  --color-background-secondary: #FDFCF9;\n  --color-background-light: #FDFCF9;\n  --color-surface: #FFFFFF;\n  \n  /* Accent Colors */\n  --color-accent-green: #6B7F5C;\n  --color-accent-green-light: #8A9F7B;\n  --color-accent-green-dark: #4C5F3D;\n  \n  --color-accent-terracotta: #C17A5C;\n  --color-accent-terracotta-light: #D4967E;\n  --color-accent-terracotta-dark: #A65E40;\n  \n  /* Status Colors */\n  --color-success: #7FA876;\n  --color-success-bg: #E8F3E5;\n  \n  --color-warning: #D9A84E;\n  --color-warning-bg: #FFF4E0;\n  \n  --color-error: #C76B6B;\n  --color-error-bg: #FDEAEA;\n  \n  --color-processing: #8B7FA8;\n  --color-processing-bg: #F0EDF5;\n  \n  /* Neutral Colors */\n  --color-text-primary: #2E2E2E;\n  --color-text-secondary: #5A5A5A;\n  --color-text-tertiary: #8A8A8A;\n  \n  --color-border: #E0DDD5;\n  --color-border-light: #EFEEE8;\n  \n  /* Layout-specific colors */\n  --color-charcoal: #2E2E2E;\n  --color-beige: #F5F1E8;\n  --color-olive: #6B7F5C;\n  --color-terracotta: #C17A5C;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 3px rgba(46, 46, 46, 0.08);\n  --shadow-md: 0 4px 12px rgba(46, 46, 46, 0.1);\n  --shadow-lg: 0 8px 24px rgba(46, 46, 46, 0.12);\n  \n  /* Spacing */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 16px;\n  --spacing-lg: 24px;\n  --spacing-xl: 32px;\n  --spacing-2xl: 48px;\n  \n  /* Border Radius */\n  --radius-sm: 6px;\n  --radius-md: 8px;\n  --radius-lg: 14px;\n  --radius-full: 9999px;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--color-background);\n  color: var(--color-text-primary);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Global button styles converted from App.css */\n@layer base {\n  button {\n    font-family: inherit;\n    transition: all 0.2s ease;\n    box-sizing: border-box;\n  }\n\n  button:focus {\n    outline: 2px solid var(--color-accent-green);\n    outline-offset: 2px;\n  }\n}\n\n/* Leave Management Styles */\n.page-container {\n  min-height: 100vh;\n  background-color: var(--color-background);\n  padding: 2rem;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding: 1.5rem 2rem;\n  background-color: var(--color-surface);\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid var(--color-border-light);\n}\n\n.page-header h1 {\n  font-size: 1.75rem;\n  color: var(--color-primary);\n  margin: 0;\n  font-weight: 600;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.stat-card {\n  background-color: var(--color-surface);\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid var(--color-border-light);\n  text-align: center;\n}\n\n.stat-card h3 {\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  margin: 0 0 0.5rem 0;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.stat-value {\n  font-size: 2rem;\n  color: var(--color-primary);\n  font-weight: 700;\n  margin: 0;\n}\n\n.stat-label {\n  font-size: 0.75rem;\n  color: var(--color-text-tertiary);\n  margin-top: 0.25rem;\n}\n\n.filters-section {\n  background-color: var(--color-surface);\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid var(--color-border-light);\n  margin-bottom: 2rem;\n}\n\n.filters-row {\n  display: flex;\n  gap: 1rem;\n  align-items: end;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 150px;\n}\n\n.filter-group label {\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.filter-group select,\n.filter-group input {\n  padding: 0.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  font-size: 0.875rem;\n  background-color: var(--color-surface);\n}\n\n.table-container {\n  background-color: var(--color-surface);\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid var(--color-border-light);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 720px;\n}\n\n.data-table th {\n  background-color: var(--color-background);\n  padding: 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  border-bottom: 1px solid var(--color-border);\n  font-size: 0.875rem;\n}\n\n.data-table td {\n  padding: 1rem;\n  border-bottom: 1px solid var(--color-border-light);\n  font-size: 0.875rem;\n  color: var(--color-text-primary);\n}\n\n.data-table tr:hover {\n  background-color: var(--color-background-light);\n}\n\n.status-badge {\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.status-pending {\n  background-color: var(--color-warning-bg);\n  color: var(--color-warning);\n}\n\n.status-approved {\n  background-color: var(--color-success-bg);\n  color: var(--color-success);\n}\n\n.status-rejected {\n  background-color: var(--color-error-bg);\n  color: var(--color-error);\n}\n\n.leave-type {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.leave-type.full_day {\n  background-color: var(--color-error-bg);\n  color: var(--color-error);\n}\n\n.leave-type.half_day {\n  background-color: var(--color-warning-bg);\n  color: var(--color-warning);\n}\n\n.reason-cell {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rejection-reason {\n  font-size: 0.75rem;\n  color: var(--color-error);\n  font-style: italic;\n  margin-top: 0.25rem;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.processed-info {\n  font-size: 0.875rem;\n}\n\n.processed-info small {\n  color: var(--color-text-tertiary);\n}\n\n.empty-state {\n  text-align: center;\n  padding: 3rem;\n  color: var(--color-text-secondary);\n}\n\n.loading-message {\n  text-align: center;\n  padding: 3rem;\n  color: var(--color-text-secondary);\n}\n\n.error-message {\n  background-color: var(--color-error-bg);\n  color: var(--color-error);\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n  border: 1px solid var(--color-error);\n}\n\n.header-stats {\n  display: flex;\n  gap: 1rem;\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n}\n\n.stat-item {\n  padding: 0.5rem 1rem;\n  background-color: var(--color-background);\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n.employee-name {\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.employee-email {\n  color: var(--color-text-tertiary);\n  font-size: 0.75rem;\n}\n\n.text-muted {\n  color: var(--color-text-tertiary);\n  font-style: italic;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: var(--color-surface);\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  border-bottom: 1px solid var(--color-border-light);\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  color: var(--color-primary);\n  font-weight: 600;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  padding: 0;\n  width: 2rem;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.modal-close:hover {\n  background-color: var(--color-background);\n}\n\n.modal-form {\n  padding: 1.5rem;\n}\n\n.modal-body {\n  padding: 1.5rem;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding: 1.5rem;\n  border-top: 1px solid var(--color-border-light);\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  font-size: 0.875rem;\n  background-color: var(--color-surface);\n  transition: border-color 0.2s;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--color-accent-green);\n  box-shadow: 0 0 0 2px rgba(107, 127, 92, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.char-count {\n  font-size: 0.75rem;\n  color: var(--color-text-tertiary);\n  margin-top: 0.25rem;\n  display: block;\n}\n\n/* Button Styles */\n.btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: var(--color-accent-green);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: var(--color-accent-green-dark);\n}\n\n.btn-secondary {\n  background-color: var(--color-background);\n  color: var(--color-text-primary);\n  border: 1px solid var(--color-border);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: var(--color-background-secondary);\n}\n\n.btn-success {\n  background-color: var(--color-success);\n  color: white;\n}\n\n.btn-success:hover:not(:disabled) {\n  background-color: #6B9462;\n}\n\n.btn-danger {\n  background-color: var(--color-error);\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: #B55555;\n}\n\n.btn-sm {\n  padding: 0.5rem 1rem;\n  font-size: 0.75rem;\n}\n/*\n Leave Management Styles */\n.leave-balances-section {\n  margin: 2rem 0;\n}\n\n.balance-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-top: 1rem;\n}\n\n.balance-card {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.balance-card.critical {\n  border-left: 4px solid var(--color-error);\n}\n\n.balance-card.warning {\n  border-left: 4px solid var(--color-warning);\n}\n\n.balance-card.good {\n  border-left: 4px solid var(--color-success);\n}\n\n.balance-header {\n  display: flex;\n  justify-content: between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.balance-header h3 {\n  margin: 0;\n  color: var(--color-text-primary);\n}\n\n.leave-type-color {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  margin-left: auto;\n}\n\n.balance-info {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.balance-stat {\n  text-align: center;\n}\n\n.balance-stat .label {\n  display: block;\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  margin-bottom: 0.25rem;\n}\n\n.balance-stat .value {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.balance-stat .value.remaining {\n  color: var(--color-success);\n}\n\n.balance-progress {\n  margin-top: 1rem;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background-color: var(--color-border-light);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background-color: var(--color-accent-green);\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  display: block;\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  margin-top: 0.5rem;\n}\n\n/* Leave Type Management */\n.tab-navigation {\n  display: flex;\n  border-bottom: 1px solid var(--color-border);\n  margin-bottom: 2rem;\n}\n\n.tab-button {\n  padding: 1rem 2rem;\n  border: none;\n  background: none;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.tab-button:hover {\n  color: var(--color-text-primary);\n}\n\n.tab-button.active {\n  color: var(--color-accent-green);\n  border-bottom-color: var(--color-accent-green);\n}\n\n.form-section {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n/* Dashboard-style responsive behavior */\n@media (max-width: 1024px) {\n  .page-container {\n    padding: 1.5rem;\n  }\n\n  .page-header {\n    padding: 1rem 1.25rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .page-container {\n    min-height: auto;\n    padding: 1rem;\n  }\n\n  .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n    padding: 1rem;\n  }\n\n  .filters-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filter-group {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .stats-grid {\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n    gap: 1rem;\n  }\n\n  .balance-cards {\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 1rem;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .modal-actions {\n    flex-direction: column-reverse;\n  }\n\n  .modal-actions .btn {\n    width: 100%;\n  }\n}\n\n.color-preview {\n  width: 30px;\n  height: 30px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border);\n}\n\n.leave-type-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.leave-type-indicator {\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n.duration-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.duration-badge.full_day {\n  background-color: var(--color-success-bg);\n  color: var(--color-success);\n}\n\n.duration-badge.half_day {\n  background-color: var(--color-warning-bg);\n  color: var(--color-warning);\n}\n\n/* Weekly Off Configuration */\n.weekly-off-config {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.day-selection {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.day-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.day-checkbox:hover {\n  background-color: var(--color-background-light);\n}\n\n.day-checkbox input:checked + .day-name {\n  color: var(--color-accent-green);\n  font-weight: 600;\n}\n\n.weekly-off-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.weekly-off-item {\n  padding: 0.5rem 1rem;\n  background-color: var(--color-background-light);\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n}\n\n/* Balance Cards Grid */\n.balance-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.balance-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.stat-item {\n  text-align: center;\n}\n\n.stat-label {\n  display: block;\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  margin-bottom: 0.25rem;\n}\n\n.stat-value {\n  display: block;\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--color-text-primary);\n}\n\n/* Bulk Assignment */\n.bulk-assignment-row {\n  display: grid;\n  grid-template-columns: 2fr 2fr 1fr auto;\n  gap: 1rem;\n  align-items: end;\n  margin-bottom: 1rem;\n  padding: 1rem;\n  background-color: var(--color-background-light);\n  border-radius: 8px;\n}\n\n.bulk-assignment-controls {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n/* Utilization Bar */\n.utilization-bar {\n  position: relative;\n  width: 100px;\n  height: 20px;\n  background-color: var(--color-border-light);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.utilization-fill {\n  height: 100%;\n  background-color: var(--color-accent-green);\n  transition: width 0.3s ease;\n}\n\n.utilization-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n/* Status Badges */\n.badge {\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.badge-success {\n  background-color: var(--color-success-bg);\n  color: var(--color-success);\n}\n\n.badge-warning {\n  background-color: var(--color-warning-bg);\n  color: var(--color-warning);\n}\n\n.badge-error {\n  background-color: var(--color-error-bg);\n  color: var(--color-error);\n}\n\n/* Year Selector */\n.year-selector {\n  padding: 0.5rem 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  background-color: var(--color-surface);\n  color: var(--color-text-primary);\n}\n\n/* Section Headers */\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.section-header h2 {\n  margin: 0;\n  color: var(--color-text-primary);\n}\n\n.section-header p {\n  margin: 0.5rem 0 0 0;\n  color: var(--color-text-secondary);\n}\n\n/* Current Config */\n.current-config {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 2rem;\n}\n\n.current-config h3 {\n  margin-top: 0;\n  color: var(--color-text-primary);\n}\n\n/* Leave Balance Assignment */\n.assignment-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.assignment-form .form-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .balance-cards {\n    grid-template-columns: 1fr;\n  }\n  \n  .balance-cards-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .day-selection {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .bulk-assignment-row {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n}/* E\nmployee Search */\n.employee-search {\n  margin-bottom: 2rem;\n}\n\n.search-input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  background-color: var(--color-surface);\n  color: var(--color-text-primary);\n  font-size: 0.875rem;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--color-accent-green);\n  box-shadow: 0 0 0 2px rgba(107, 127, 92, 0.1);\n}\n\n.search-input::placeholder {\n  color: var(--color-text-tertiary);\n}\n\n/* Text warning styles */\n.text-warning {\n  color: var(--color-warning);\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n  display: block;\n}\n\n/* Assignment form section */\n.assignment-form-section {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.assignment-form-section h2 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  color: var(--color-text-primary);\n}\n\n/* ── Video Carousel – hide scrollbar ── */\n.no-scrollbar {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.no-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n/* ── Animations ── */\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(24px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n@keyframes slideIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n.animate-slideUp { animation: slideUp 0.3s cubic-bezier(0.16,1,0.3,1) both; }\n.animate-slideIn { animation: slideIn 0.2s ease both; }\n\n/* ══════════════════════════════════════════════════════════════════════════\n   Application Stepper Navigation Styles\n   ══════════════════════════════════════════════════════════════════════════ */\n\n/* ── Workflow Section Container Transitions ── */\n.workflow-section-container {\n  transition: opacity 300ms ease-in-out;\n  will-change: opacity;\n}\n\n/* Fade in animation for entering sections */\n.workflow-section-enter {\n  opacity: 0;\n}\n\n.workflow-section-enter-active {\n  opacity: 1;\n  transition: opacity 300ms ease-in-out;\n}\n\n/* Fade out animation for exiting sections */\n.workflow-section-exit {\n  opacity: 1;\n}\n\n.workflow-section-exit-active {\n  opacity: 0;\n  transition: opacity 300ms ease-in-out;\n}\n\n/* ── Stepper Step States ── */\n\n/* Active step styling - highlighted with ring effect */\n.stepper-step-active {\n  background-color: #2563eb; /* blue-600 */\n  color: white;\n  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);\n  transform: scale(1.05);\n}\n\n.stepper-step-active-label {\n  color: #2563eb; /* blue-600 */\n  font-weight: 600;\n}\n\n/* Completed step styling - green with checkmark */\n.stepper-step-completed {\n  background-color: #22c55e; /* green-500 */\n  color: white;\n}\n\n.stepper-step-completed-label {\n  color: #16a34a; /* green-600 */\n  font-weight: 500;\n}\n\n/* Disabled/future step styling - muted appearance */\n.stepper-step-disabled {\n  background-color: #e5e7eb; /* gray-200 */\n  color: #9ca3af; /* gray-400 */\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.stepper-step-disabled-label {\n  color: #9ca3af; /* gray-400 */\n}\n\n/* Accessible step styling - can be clicked */\n.stepper-step-accessible {\n  background-color: #d1d5db; /* gray-300 */\n  color: #4b5563; /* gray-600 */\n  cursor: pointer;\n  transition: all 200ms ease-in-out;\n}\n\n.stepper-step-accessible:hover {\n  background-color: #9ca3af; /* gray-400 */\n  transform: scale(1.05);\n}\n\n.stepper-step-accessible:focus {\n  outline: 2px solid var(--color-accent-green);\n  outline-offset: 2px;\n}\n\n/* ── Step Connector Lines ── */\n.stepper-connector {\n  height: 2px;\n  background-color: #d1d5db; /* gray-300 */\n  transition: background-color 200ms ease-in-out;\n}\n\n.stepper-connector-completed {\n  background-color: #22c55e; /* green-500 */\n}\n\n/* ── Focus States for Accessibility ── */\n.stepper-step:focus-visible {\n  outline: 2px solid var(--color-accent-green);\n  outline-offset: 3px;\n  border-radius: 50%;\n}\n\n.stepper-step:focus:not(:focus-visible) {\n  outline: none;\n}\n\n/* ── Mobile Responsive Styles ── */\n@media (max-width: 767px) {\n  /* Ensure touch-friendly targets on mobile */\n  .stepper-step-mobile {\n    min-width: 44px;\n    min-height: 44px;\n    touch-action: manipulation;\n  }\n\n  /* Mobile stepper container - horizontal scroll */\n  .stepper-mobile-container {\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n    scrollbar-color: #d1d5db transparent;\n  }\n\n  .stepper-mobile-container::-webkit-scrollbar {\n    height: 4px;\n  }\n\n  .stepper-mobile-container::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  .stepper-mobile-container::-webkit-scrollbar-thumb {\n    background-color: #d1d5db;\n    border-radius: 2px;\n  }\n\n  /* Abbreviated labels on mobile */\n  .stepper-label-mobile {\n    font-size: 0.75rem;\n    max-width: 60px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  /* Smaller connector lines on mobile */\n  .stepper-connector-mobile {\n    width: 32px;\n    height: 2px;\n    margin: 0 4px;\n  }\n}\n\n/* ── Desktop Responsive Styles ── */\n@media (min-width: 768px) {\n  /* Full labels on desktop */\n  .stepper-label-desktop {\n    font-size: 0.875rem;\n    white-space: nowrap;\n  }\n\n  /* Larger step circles on desktop */\n  .stepper-step-desktop {\n    width: 40px;\n    height: 40px;\n  }\n\n  /* Flexible connector lines on desktop */\n  .stepper-connector-desktop {\n    flex: 1;\n    height: 2px;\n    margin: 0 8px;\n  }\n}\n\n/* ── Transition Performance Optimization ── */\n.workflow-section-container,\n.stepper-step,\n.stepper-connector {\n  /* Use GPU acceleration for smoother transitions */\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n\n/* ── Accessibility: Screen Reader Only Content ── */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n/* ── High Contrast Mode Support ── */\n@media (prefers-contrast: high) {\n  .stepper-step-active {\n    border: 2px solid currentColor;\n  }\n\n  .stepper-step-completed {\n    border: 2px solid currentColor;\n  }\n\n  .stepper-step-disabled {\n    border: 2px solid currentColor;\n  }\n}\n\n/* ── Reduced Motion Support ── */\n@media (prefers-reduced-motion: reduce) {\n  .workflow-section-container,\n  .workflow-section-enter-active,\n  .workflow-section-exit-active,\n  .stepper-step,\n  .stepper-connector {\n    transition: none;\n    animation: none;\n  }\n}\n\n/* ── Loading State for Transitions ── */\n.workflow-section-loading {\n  opacity: 0.5;\n  pointer-events: none;\n  transition: opacity 150ms ease-in-out;\n}\n\n/* ── Step Number and Icon Styling ── */\n.stepper-step-number {\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.stepper-step-icon {\n  width: 20px;\n  height: 20px;\n}\n\n/* ── Stepper Navigation Container ── */\n.stepper-nav {\n  background-color: white;\n  border-bottom: 1px solid #e5e7eb;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n/* ── Step Label Truncation ── */\n.stepper-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100px;\n}\n\n@media (min-width: 768px) {\n  .stepper-label {\n    max-width: 120px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .stepper-label {\n    max-width: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
